import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  SelectDropDown
} from 'components/common/Elements/Elements';

import { createFilterSize } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  let companySize = [];

  const numberОfFilters = 7;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  (function () {
    createFilterSize(filters.companySize, companySize);
  })();

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.healthStatus}
        input={{ value: filter.healthStatus, onChange: handleFilter }}
        name={'healthStatus'}
        label={t('activity:filters.HEALTH_STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.status}
        input={{ value: filter.status, onChange: handleFilter }}
        name={'status'}
        label={t('activity:filters.STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={companySize}
        input={{ value: filter.companySize, onChange: handleFilter }}
        name={'companySize'}
        label={t('activity:filters.COMPANY_SIZE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.plan}
        input={{ value: filter.plan, onChange: handleFilter }}
        name={'plan'}
        label={t('activity:filters.PRICING_PLAN')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.billingCycle}
        input={{ value: filter.billingCycle, onChange: handleFilter }}
        name={'billingCycle'}
        label={t('activity:filters.BILLING_CYCLE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.customerSuccessEngineer}
        input={{
          value: filter.customerSuccessEngineer,
          onChange: handleFilter
        }}
        name={'customerSuccessEngineer'}
        label={t('activity:about.CS_ENGINEER')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.accountManager}
        input={{ value: filter.accountManager, onChange: handleFilter }}
        name={'accountManager'}
        label={t('activity:filters.ACCOUNT_MANAGER_')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />

      <ClearButton
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
